{
  "": "",
  "actions": {
    "update": "Frissítés",
    "updated": "Frissítve"
  },
  "buttons": {
    "accept": "Jóváhagyás",
    "assignTicket": "Jegy hozzárendelése",
    "assignTicketOfName": "„{name}” jegy hozzárendelése",
    "cancel": "Mégse",
    "checklistContinueAnyway": "Nem minden kész: Folytatás mindenképp",
    "checklistUndoContinue": "Nyitott feladatok megoldása",
    "connect": "Összekapcsolás",
    "delete": "Törlés",
    "downloadFile": "Fájl letöltése",
    "downloadFileWithName": "A(z) \"{name}\" fájl letöltése",
    "exportCSV": "Exportálás CSV-ként",
    "hide": "Elrejtés",
    "large": "Nagy",
    "lockUnlocked": "Kész – zárolás",
    "newTicket": "Új jegy",
    "nextProcessStep": "Következő lépésre",
    "nextStep": "A(z) „{stepName}” lépésre",
    "no": "Nem",
    "normal": "Normál",
    "reject": "Elutasítás",
    "revert": "Visszaállítás",
    "save": "Mentés",
    "selectAttachments": "Mellékletek",
    "send": "Küldés",
    "show": "Megjelenítés",
    "showLess": "Kevesebb megjelenítése",
    "showMore": "Több megjelenítése",
    "small": "Kicsi",
    "uiPluginContinueAnyway": "Nem minden kész: Folytatás mindenképp",
    "uiPluginUndoContinue": "Nyitott feladatok megoldása",
    "unlockLocked": "Nem kész – mégis feloldás",
    "update": "Frissítés",
    "yes": "Igen"
  },
  "confirm": {
    "default": {
      "header": "Megerősítés",
      "message": "Folytatni szeretné?"
    },
    "delete": {
      "header": "Bejegyzés törlése",
      "message": "Valóban törli ezt a bejegyzést?"
    },
    "nextStep": {
      "header": "Befejezte ezt a feladatrészt?",
      "message": "Ezt a lépést később nem lehet visszavonni."
    },
    "save": {
      "header": "Bejegyzés mentése",
      "message": "Valóban menteni szeretné ezt a bejegyzést?"
    }
  },
  "enums": {
    "AC_BLUEPRINT": "Vázlat komponens",
    "AC_CHECKLIST": "Ellenőrzőlista",
    "AC_CONTRACTS": "Szerződések",
    "AC_DOCUMENTUPLOAD": "Feltöltő modul",
    "AC_EMAIL": "Email",
    "AC_LOCATIONLIST": "Helyszínlista",
    "AC_NONE": "Nincs kapcsolt komponens",
    "AC_SKETCH": "Sketch-komponens",
    "AC_STAMPING": "Ellenőrző bélyeg",
    "AC_UPLOAD": "Dokumentumfeltöltés",
    "ACTIVE": "Aktív",
    "AD_SPACE": "Reklámfelület",
    "ADDITIONALCOSTADVANCEPAYMENT": "Járulékos költség előleg",
    "ADDITIONALCOSTFLATRATEEURO": "Járulékos költség átalány (euró)",
    "ADDITIONALCOSTFLATRATEPERCENTAGE": "Járulékos költség átalány (százalék)",
    "ADVERTISING_ASSOCIATION": "Reklámközösség",
    "ADVERTISINGCOSTS": "Reklámköltségek",
    "ANCILLARY_AREA": "Mellékterület",
    "AREA": "Terület",
    "AUTOMATIC": "Automatikus",
    "AUTOMATIC_EXTENSION": "Automatikus hosszabbítás",
    "AVAILABLE": "Elérhető",
    "BASERENT": "Alapbérleti díj",
    "CENTER_MANAGEMENT": "Központi menedzsment",
    "CLOSED": "lezárt",
    "COMMERCIALCENTRE": "Bevásárlóközpont",
    "COMPLETED": "Befejezve",
    "CONCESSION_AREA": "Konzessziós terület",
    "CREDITOR_PAYEE_": "Hitelező (kedvezményezett)",
    "DAY": "Nap | Napok",
    "DAY_S": "{count} nap | {count} nap",
    "DE": "Német",
    "DEADLINE_COUNTDOWN": "Még {count} munkanap | Még {count} munkanap",
    "DEADLINE_OVERDUE": "Határidő közeleg: {date}",
    "DEADLINE_OVERDUE_WARN": "Lejárt! Határidő vége: {date}",
    "DEADLINE_TRIGGER": "Határidő-trigger",
    "DISCOUNT_PERCENTAGE": "Kedvezmény",
    "DR_": "Dr",
    "EN": "Angol",
    "ENGLISH": "Angol",
    "FR": "Francia",
    "FRENCH": "Francia",
    "GERMAN": "Német",
    "HEATINGCOSTADVANCE_PAYMENT": "Fűtési költség előleg",
    "HIGH": "Magas",
    "HU": "Magyar",
    "HUNGARIAN": "Magyar",
    "IN_PROGRESS": "folyamatban",
    "IN_PROGRESS_OVERDUE": "folyamatban (lejárt)",
    "IN_PROGRESS_OVERDUE_WARN": "erősen lejárt",
    "IS_ACTIVE": "Aktív",
    "LANDLORD": "Bérbeadó",
    "LEASE": "Lízing",
    "LEASE_CONTRACT": "Bérleti szerződés",
    "LOG_TRIGGER": "Naplózó trigger",
    "LOW": "Alacsony",
    "MAIN_AREA": "Főterület",
    "MAINTENANCE_CONTRACT": "Karbantartási szerződés",
    "MEDIUM": "Közepes",
    "MINIMUMRENT": "Minimális bérleti díj",
    "MONTH": "Hónap | Hónapok",
    "MONTH_S": "{count} hónap | {count} hónap",
    "MR_": "Úr",
    "MRS_": "Asszony",
    "MS_": "Kisasszony",
    "NEW": "új",
    "OFFICEBUILDING": "Irodaház",
    "OPEN": "nyitott",
    "OPEN_OVERDUE": "esedékes",
    "OPEN_OVERDUE_WARN": "lejárt",
    "OTHER": "Egyéb",
    "OUTLET": "Outlet",
    "OVERDUE": "esedékes",
    "OVERDUE_WARN": "erősen lejárt",
    "PARKING_AREA": "Parkoló terület",
    "PARTLY": "részben kész",
    "PRIORITY_LEVEL": "Prioritás",
    "PROCESSED": "osztályozott",
    "PROF_": "Prof",
    "PROF_DR_": "Prof Dr",
    "PROPERTY_LANDLORD": "Ingatlan bérbeadó",
    "PROPERTY_MANAGER": "Ingatlan kezelő",
    "PROPERTY_OWNER": "Ingatlan tulajdonos",
    "PROPERTY_TENANT": "Ingatlan bérlő",
    "PURCHASE_AGREEMENT": "Adásvételi szerződés",
    "REGION": "Régió",
    "RENTAL": "Bérbeadás",
    "RETAILCENTER": "Kereskedelmi központ",
    "SALES": "Értékesítés",
    "SAMPLE_KOMPONENTE_A": "Példa komponens (nincs értelme)",
    "SERVICE_AGREEMENT": "Szolgáltatási szerződés",
    "SKIP": "Kihagyva",
    "SPECIAL_RESILIATION": "Rendkívüli felmondás",
    "STANDALONE": "Önálló",
    "START_DATE": "Kezdő dátum",
    "STORAGE": "Raktár",
    "TEAM_A-TEAM": "Matze Taskforce",
    "TEAM_BO": "Backoffice",
    "TEAM_BUHA": "Könyvelés",
    "TEAM_BUHA_CUST": "Ügyfél – könyvelés",
    "TEAM_FM": "Facility management",
    "TEAM_FM_CUST": "Ügyfél – facility management",
    "TEAM_FOMA": "Követeléskezelés",
    "TEAM_MVM": "Bérleti szerződés menedzsment",
    "TEAM_MVM_LAW": "Ügyvéd – bérleti menedzsment",
    "TEAM_MVM_LAWYER": "Ügyvéd – bérleti menedzsment",
    "TEAM_NKA": "Közüzemi elszámolás",
    "TEAM_NKA_CUST": "Ügyfél – közüzemi elszámolás",
    "TEAM_NONE": "Nincs csapat",
    "TENANT": "Bérlő",
    "TENANT_AND_LANDLORD": "Bérlő és bérbeadó",
    "TENANT_OR_LANDLORD": "Bérlő vagy bérbeadó",
    "TICKETSTATUS_CLOSED": "lezárt",
    "TICKETSTATUS_IN_PROGRESS": "folyamatban",
    "TICKETSTATUS_IN_PROGRESS_OVERDUE": "folyamatban (lejárt)",
    "TICKETSTATUS_IN_PROGRESS_OVERDUE_WARN": "erősen lejárt",
    "TICKETSTATUS_NEW": "új",
    "TICKETSTATUS_OPEN": "nyitott",
    "TICKETSTATUS_OPEN_OVERDUE": "esedékes",
    "TICKETSTATUS_OPEN_OVERDUE_WARN": "lejárt",
    "TICKETSTATUS_OVERDUE": "esedékes",
    "TICKETSTATUS_OVERDUE_WARN": "erősen lejárt",
    "TURNOVERBASEDRENT": "Forgalomarányos bérleti díj",
    "TURNOVERBASEDRENTADVANCEPAYMENT": "Forgalomarányos bérleti díj előleg",
    "UNAVAILABLE": "Nem elérhető",
    "UNPROCESSED": "feldolgozatlan",
    "UTILITY_MANAGER": "Rezsi kezelő",
    "WEEK": "Hét | Hetek",
    "WEEK_S": "{count} hét | {count} hét",
    "WIDGET_CLASSIFIED": "feldolgozatlan",
    "WIDGET_NOT_CLASSIFIED": "feldolgozott",
    "WIDGET_STATUS_IN_PROGRESS": "folyamatban",
    "WIDGET_STATUS_IN_PROGRESS_OVERDUE": "esedékes",
    "WIDGET_STATUS_IN_PROGRESS_OVERDUE_WARN": "lejárt",
    "WIDGET_STATUS_NEW": "új",
    "WIDGET_STATUS_OPEN": "nyitott",
    "WIDGET_STATUS_OPEN_OVERDUE": "esedékes, feldolgozatlan",
    "WIDGET_STATUS_OPEN_OVERDUE_WARN": "lejárt, feldolgozatlan",
    "WIDGET_STATUS_OVERDUE": "esedékes",
    "WIDGET_STATUS_OVERDUE_WARN": "lejárt",
    "WIDGET_STATUS_TICKETSTATUS_CLOSED": "lezárt",
    "YEAR": "Év | Évek",
    "YEAR_S": "{count} év | {count} év"
  },
  "errors": {
    "CANNOT_BE_CREATED": "Elem nem hozható létre",
    "CANNOT_BE_DELETED": "Elem nem törölhető",
    "CANNOT_BE_FOUND": "Elem nem található",
    "CANNOT_BE_UPDATED": "Elem nem frissíthető",
    "invalidIban": "Ez nem érvényes IBAN",
    "required": "Kötelező mező"
  },
  "info": {
    "SUCCESS_CREATE": "Az elem sikeresen létrejött",
    "SUCCESS_DELETE": "Az elem sikeresen törölve",
    "SUCCESS_UPDATE": "Az elem sikeresen frissítve"
  },
  "labels": {
    "accountingArea": "Könyvelési terület",
    "actingBy": "Képviseli",
    "action": "Művelet",
    "actionStart": "Művelet kezdete",
    "activate": "Aktiválás",
    "add": "Új bejegyzés",
    "additionalAddressInfo": "További cím információ",
    "address": "Cím",
    "addressId": "Cím-azonosító",
    "addressIdShort": "AID",
    "addTrigger": "Új trigger",
    "adjustmentInterval": "Kiigazítási intervallum",
    "adjustmentPossible": "Kiigazítás lehetséges",
    "alldocuments": {
      "add": "Feltöltés"
    },
    "allIDs": "Dokumentum- és email-ID-k",
    "allIDsShort": "ID-k",
    "allNamesAndSubjects": "Tárgy",
    "allocationSpace": "Kiosztott terület",
    "amount": "Összeg",
    "answerIsRequired": "Válasz szükséges",
    "approvalNr": "Jóváhagyási szám",
    "area": "Terület",
    "areaCount": "Területek száma",
    "areaName": "Név",
    "areaNameExternal": "Külső területnév",
    "areas": "Területek",
    "areaSize": "Területnagyság",
    "areasToContracts": "Területek",
    "areaToPointOfSale": "Értékesítési pontok",
    "assignTicket": "„{name}” hozzárendelése",
    "assignTicketStatic": "Jegyhez rendelés",
    "attachment": "Melléklet",
    "attachments": "Mellékletek",
    "automaticAdjustment": "Automatikus kiigazítás",
    "bankName": "Bank neve",
    "batchClassify": "Dokumentumok kötegelt osztályozása",
    "bic": "BIC",
    "boardName": "Igazgatóság neve",
    "booleanValue": "Logikai érték",
    "booleanValueShort": "Bool",
    "branchnumber": "Fiókszám",
    "brevoApiKey": "Brevo API kulcs",
    "brevoCc": "Másolat címzettek",
    "brevoReplyTo": "Válaszcím",
    "brevoSelectedTemplate": "Kiválasztott sablon",
    "brevoTemplate": "Email-sablon",
    "brevoTo": "Címzett",
    "caretaker": "Kezelő",
    "changedAt": "Frissítve",
    "changes": "Változások",
    "checklistItems": "Ellenőrzőlista",
    "checklistTopic": "Ellenőrzési feltétel",
    "checksumSHA256": "Ellenőrzőösszeg",
    "chooseFiles": "Fájlok kiválasztása",
    "city": "Város",
    "cityName": "Város neve",
    "cityZip": "Város irányítószáma",
    "classificationStatus": "Állapot",
    "code": "Kód",
    "columnName": "Oszlop neve",
    "combinedCount": "Számolja",
    "combinedExtensionValue": "Hosszabbítás",
    "combinedNoticePeriod": "Felmondási idő",
    "combinedValue": "Feltételérték",
    "comment": "Megjegyzés",
    "comments": "Megjegyzések",
    "commentText": "Megjegyzés szövege",
    "companies": "Vállalatok",
    "company": "Vállalat",
    "companyCount": "Vállalatok száma",
    "companyCountShort": "Db",
    "companyName": "Vállalat neve",
    "complete": "Befejezés",
    "conditions": "Szerződési feltételek",
    "conditionType": "Feltétel típusa",
    "conditionTypeId": "Feltételtípus ID",
    "connectedBy": "Összekapcsolta: {source}",
    "consumerPriceIndex": "Árindex",
    "contact": "Kapcsolat",
    "contactPerson": "Kapcsolattartó",
    "contactPersonToContract": "Kapcsolattartó",
    "content": "Tartalom",
    "contractAction": "Szerződés művelet",
    "contractactions": "Szerződés műveletek",
    "contractId": "Szerződés ID",
    "contractingParties": "Szerződő felek",
    "contracts": "Szerződések",
    "contractsAreaValidity": "Hatály területe",
    "contractsDates": "Érvényességi időszak",
    "contractsHeader": "Szerződésfej",
    "contractsParties": "Szerződő felek",
    "contractsPartiesGiver": "Szerződésadó",
    "contractsPartiesTaker": "Szerződésvevő",
    "contractType": "Szerződéstípus",
    "contractTypeId": "Szerződéstípus ID",
    "contradictionPackages": "Vitatási csomagok",
    "contributionOneTime": "Egyszeri befizetés",
    "contributionRecurring": "Ismétlődő befizetés",
    "costCenter": "Költséghely",
    "country": "Ország",
    "countryCode": "Országkód",
    "countryName": "Országnév",
    "createdAt": "Létrehozva",
    "currency": "Pénznem",
    "customer": "Ügyfél",
    "customerBankingAccount": "Bankszámla",
    "customerCode": "Ügyfélkód",
    "customerCount": "Ügyfelek száma",
    "customerCountry": "Ügyfél országa",
    "customerCountShort": "Db",
    "customerGroup": "Ügyfélcsoport",
    "customergroupDescription": "Leírás",
    "customerGroupId": "Ügyfélcsoport azonosító",
    "customergroupName": "Ügyfélcsoport neve",
    "customergroupNameShort": "Név",
    "customerGroups": "Ügyfélcsoportok",
    "customerId": "Ügyfél ID",
    "customerIdShort": "Ügyf-ID",
    "customerName": "Ügyfél neve",
    "customers": "Ügyfelek",
    "dateValue": "Dátum",
    "dayOfMonth": "Hónap napja",
    "deActivate": "Deaktiválás",
    "deactivate": "Deaktiválás",
    "deadline": "Határidő",
    "deadlineOffset": "Határidő eltolás",
    "deadlineOverdue": "Határidő lejárt",
    "deadlineRisk": "Határidő kockázat",
    "definiteActionEnd": "Végleges műveleti befejezés",
    "delete": "Törlés",
    "deleteMany": "{count} bejegyzés törlése | {count} bejegyzés törlése",
    "description": "Leírás",
    "descriptionUiPluginParam": "Példa leírás",
    "detailDescription": "Részletes leírás",
    "discountPercentage": "Kedvezmény",
    "documentId": "Dokumentum ID",
    "documentName": "Dokumentum neve",
    "documents": "Dokumentumok",
    "documentType": "Dokumentum típusa",
    "documentTypes": "Dokumentum típusa",
    "documentVersion": "Dokumentum verzió",
    "documentVersionShort": "Dok. v.",
    "earliestEffectiveDate": "Legkorábbi hatálybalépés",
    "edit": "Szerkesztés",
    "editorName": "Szerkesztő",
    "effectiveDate": "Hatály dátuma",
    "eMail": "E-mail",
    "email": "E-mail",
    "emailId": "Email-azonosító",
    "emailLink": "E-mail link",
    "emails": "E-mailek",
    "endDate": "Záró dátum",
    "entryDate": "Beérkezés dátuma",
    "enumValue": "Felsorolás érték",
    "enumValueShort": "Enum",
    "eventType": "Esemény",
    "exportAll": "összes",
    "exportAllColumns": "összes",
    "exportColumnScope": "Oszlopok",
    "exportDataType": "Adatformátum",
    "exportFiltered": "szűrt",
    "exportFormatted": "formázott",
    "exportRaw": "nyers",
    "exportScope": "Rekordok",
    "exportVisibleColumns": "látható",
    "extension": "Hosszabbítás",
    "extensionUnit": "Hosszabbítás egysége",
    "extensionValue": "Hosszabbítás opció",
    "extensionValueShort": "Hossz.",
    "extra": "Extra",
    "favAdd": "Kedvencekhez adás",
    "favRemove": "Kedvenc eltávolítása",
    "fileName": "Fájlnév",
    "filtered": "szűrt",
    "filterOnPOS": "Szűrés értékesítési pontra",
    "firstName": "Keresztnév",
    "firstPossibleEndDate": "Első lehetséges záró dátum",
    "firstYear": "Első év",
    "generalLeaderAccount": "Főkönyvi számla",
    "generalLeaderAccountNr": "Főkönyvi szám",
    "germanFederalState": "Tartomány",
    "group": "Csoport",
    "handOverDate": "Átadás dátuma",
    "houseNumber": "Házszám",
    "iban": "IBAN",
    "ibanId": "IBAN azonosító",
    "id": "ID",
    "includeAllAttachments": "Minden melléklet bevonása",
    "indexChange": "Változás",
    "indexTransfer": "Továbbadás",
    "internal": "Belső",
    "interval": "Intervallum (hónap)",
    "isActive": "Aktív",
    "isActiveValue": "Aktív",
    "isClassificationNotApplicable": "Nem szükséges osztályozni",
    "isClassified": "Osztályozott",
    "isClassifiedShort": "Oszt.",
    "isDraft": "Vázlat",
    "isDraftShort": "Vázl.",
    "isGroupAdmin": "Csoportadminisztrátor",
    "isIndexPayment": "Indexklauzula",
    "isInternal": "Belső",
    "isMainAccount": "Főszámla",
    "isRecurring": "Ismétlődő",
    "isSeyboldUser": "Seybold-felhasználó",
    "isTemplateEditable": "Szerkeszthető:",
    "isTemplateEditableFalse": "Helyőrzők",
    "isTemplateEditableTrue": "Minden",
    "jobTitle": "Beosztás",
    "languageOfCorrespondence": "Levelezés nyelve",
    "lastName": "Vezetéknév",
    "lastPossibleContractEnd": "Végső lehetséges szerződés vége",
    "Lease": "Lízing",
    "location": "Helyszín",
    "locationAddress": "Cím",
    "locationArea": "Terület",
    "locationId": "Helyszín azonosító",
    "locationIdShort": "Loc-ID",
    "locationName": "Helyszín neve",
    "locations": "Helyszínek",
    "logText": "Napló üzenet",
    "mailContent": "E-mail tartalom",
    "Maintenance Contract": "Karbantartási szerződés",
    "mainUsage": "Fő használat",
    "managerName": "Menedzser neve",
    "maxCount": "Hosszabbítások max. száma",
    "maxCountShort": "Max. db",
    "mimeType": "Dokumentumtípus",
    "mobile": "Mobil",
    "modifiedAt": "Módosítva",
    "month": "Hónap",
    "moveinTime": "Beköltözés ideje",
    "moveoutTime": "Kiköltözés ideje",
    "name": "Név",
    "nameExternal": "Külső",
    "newTicket": "Új jegy",
    "nextPossibleContractEnd": "Következő lehetséges szerződés vége",
    "nextStepAction": "Következő lépés",
    "noAttachments": "Nincsenek mellékletek",
    "noPlugins": "Nincsenek bővítmények",
    "notes": "Jegyzetek",
    "noteText": "Jegyzet szöveg",
    "noticePeriod": "Felmondási idő",
    "noticePeriodShort": "Idő",
    "noticePeriodUnit": "Felmondási idő egysége",
    "noTicketFound": "Nem található jegy",
    "notIncluded": "Nem tartalmazza",
    "noTriggers": "Nincsenek triggerek",
    "number": "Szám",
    "numberValue": "Számérték",
    "numberValueShort": "Szám",
    "oneTimeContribution": "Egyszeri összeg",
    "optionsAvailable": "Elérhető opciók",
    "overdueDaysSince": "Lejárt",
    "ownerName": "Tulajdonos neve",
    "parentId": "Szülő ID",
    "partnephonerCount": "Partnercsoportok száma",
    "partnephonerCountShort": "PG-k",
    "partner": "Partner",
    "partnerBankingAccount": "Partner bankszámla",
    "partnercompany": "Csoport besorolás",
    "partnerCount": "Partnerek száma",
    "partnerCountShort": "Db",
    "partnerGroup": "Partner vállalat",
    "partnerGroupId": "Partnercsoport azonosító",
    "partnerGroupIdShort": "Pg-ID",
    "partnerGroups": "Partnercsoportok",
    "partnerName": "Partner neve",
    "partners": "Partnerek",
    "passThrough": "Átvezetés",
    "payment": "Fizetés",
    "paymentType": "Fizetési mód",
    "phone": "Telefon",
    "pointOfSale": "Értékesítési pont",
    "pointOfSale_customer_customerGroup_name": "Ügyfélcsoport",
    "pointOfSale_name": "Értékesítési pontok",
    "pointOfSaleId": "POS",
    "pointOfSaleName": "Név",
    "pointOfSales": "Értékesítési pontok",
    "pointOfSalesToArea": "Területek",
    "pos": "POS",
    "posId": "Értékesítési pont ID",
    "posIdShort": "POS",
    "posName": "Értékesítési pont neve",
    "postalCode": "Irányítószám",
    "postalCodeShort": "IRSZ",
    "preferences": {
      "showContractactionsTable": "Szerződés műveletek",
      "showEmailsDoughnutChart": "Email diagram",
      "showEmailsUnclassifiedTable": "Nem osztályozott emailek",
      "showLatestOpenTicketsTable": "Legújabb nyitott jegyek",
      "showTicketsDoughnutChart": "Jegy diagram",
      "showUrgentOpenTicketsTable": "Sürgős nyitott jegyek",
      "ticketShowConfirm": "Következő lépés megerősítése",
      "ticketShowPreviewNotification": "Előnézet a következő lépésről"
    },
    "preferenceSettings": "Beállítások",
    "preferenceSettingsDashboard": "Vezérlőpult beállításai",
    "preferenceSettingsTicket": "Jegy beállításai",
    "priorityLevel": "Prioritás",
    "procdefUrl": "Folyamatlépés URL",
    "processAddStep": "Új lépés létrehozása",
    "processAddStepConnect": "Új lépés létrehozása és összekapcsolása",
    "processAddUiPlugin": "Akciókomponens hozzáadása",
    "processAssignedTeam": "Hozzárendelt csapat",
    "processAssignToNewStep": "Hozzárendelés új lépéshez",
    "processConnectPlugin": "UI-bővítmény összekapcsolása",
    "processConnectStep": "Új opció létrehozása",
    "processDeadline": "Határidő a teljes folyamathoz (munkanapok)",
    "processDeadlinedAt": "Végső határidő",
    "processDownload": "Folyamat JSON letöltése",
    "processExternal": "Külső folyamat",
    "processFinishTask": "Feladat lezárása",
    "processGotoExternalStep": "Ugrás külső folyamathoz",
    "processGotoStart": "Vissza a kezdőpontra",
    "processInitTitle": "Nevezze el és írja le a folyamatot",
    "processIsExternalStep": "Külső folyamatlépés",
    "processIsUploaded": "Feltöltve:",
    "processLoadFromJSON": "Folyamat betöltése",
    "processName": "Folyamat",
    "processNewOption": "Új opció",
    "processOptionName": "Összekapcsolás szövege",
    "processOptionNextStep": "Folyamatlépés hivatkozás",
    "processOptionNextStepAssignTeam": "Csapat hozzárendelése",
    "processOptionsNextStep": "Következő lépések opciói",
    "processPasteJSON": "JSON beillesztése",
    "processPreview": "Előnézet",
    "processRemoveOption": "Opció eltávolítása",
    "processRemovePlugin": "Bővítmény eltávolítása",
    "processRemoveTrigger": "Trigger eltávolítása",
    "processSlip": "Folyamatlap",
    "processStep": "Lépés",
    "processStepDelete": "Lépés törlése",
    "processStepDescription": "Folyamatlépés leírása",
    "processStepEdit": "Lépés szerkesztése",
    "processStepIsEnd": "Végpont",
    "processStepName": "Folyamatlépés neve",
    "processStepTriggers": "Triggerek hozzárendelése a lépéshez",
    "processStepUiPlugins": "Akciókomponensek",
    "processTree": "Szervezeti ábra",
    "processUnlinkOption": "Hivatkozás eltávolítása",
    "processUploadJSON": "JSON feltöltése",
    "profile": "Profil",
    "propertyDescription": "Leírás",
    "Purchase Agreement": "Adásvételi szerződés",
    "rawdata": "Nyers adatok",
    "receiptDate": "Beérkezés dátuma",
    "receiveDate": "Beérkezés dátuma",
    "recurringContribution": "Ismétlődő összeg",
    "reference": "Hivatkozás",
    "region": "Régió",
    "remaining": {
      "farFuture": "Távoli jövőben",
      "lessThanHalfYear": "Kevesebb mint fél év",
      "lessThanMonth": "Kevesebb mint egy hónap",
      "lessThanQuarter": "Kevesebb mint negyedév",
      "lessThanYear": "Kevesebb mint egy év"
    },
    "Rental": "Bérbeadás",
    "rentalSpace": "Bérlemény területe",
    "resiliationDate": "Megszűnés dátuma",
    "resolvedConditionType": "Feltétel típusa",
    "retroactiveAdjustment": "Visszamenőleges kiigazítás",
    "reviewer1Date": "1. ellenőrzés dátuma",
    "reviewer1Name": "1. ellenőr neve",
    "reviewer2Date": "2. ellenőrzés dátuma",
    "reviewer2Name": "2. ellenőr neve",
    "reviewPhase": "Ellenőrzési fázis",
    "role": "Szerep",
    "salutation": "Megszólítás",
    "secondStampingNotOk": "Nem ellenőrzött",
    "selected": "Kiválasztva",
    "selectedColumns": "Kiválasztott oszlopok",
    "senderEmail": "E-mail",
    "senderEmails": "E-mailek",
    "senderName": "Feladó",
    "Service Agreement": "Szolgáltatási szerződés",
    "serviceObjects": "Szolgáltatási objektumok",
    "shortDescription": "Rövid leírás",
    "size": "Méret",
    "sizeShort": "M.",
    "skip": "Kihagyás",
    "spaceValue": "Terület érték",
    "stamped": "Bélyegzett",
    "stampedShort": "Bély.",
    "stampingNotOk": "Nincs bélyeg",
    "stampingStep1": "Első ellenőrzés",
    "stampingStep2": "Második ellenőrzés",
    "startDate": "Kezdő dátum",
    "status": "Állapot",
    "statusActions": "Műveletek",
    "stepActionElement": "UI-bővítmény",
    "stepDeadline": "Határidő ehhez a lépéshez (munkanapok)",
    "stepDeadlinedAt": "Elvégzendő eddig",
    "stepLinkname": "Műveleti opció",
    "stepTriggerElement": "Trigger",
    "street": "Utca",
    "streetNumber": "Házszám",
    "stringValue": "Szöveg érték",
    "subject": "Tárgy",
    "sumAreaSpaces": "Területösszeg",
    "summary": "Összefoglaló",
    "supposedActionEnd": "Várható művelet vége",
    "tableSettingsFontsize": "Betűméret",
    "tableSettingsFooterPagination": "Lapozás a láblécben",
    "tableSettingsGrid": "Rács",
    "tableSettingsHdlBehaviour": "Tábla viselkedése",
    "tableSettingsHdlColumns": "Látható oszlopok",
    "tableSettingsHdlExportCSV": "Export CSV-be",
    "tableSettingsHdlLayout": "Tábla elrendezés",
    "tableSettingsHdlSize": "Méret",
    "tableSettingsInstantEdit": "Gyors szerkesztés",
    "tableSettingsMultiselect": "Többválasztós jelölők",
    "tableSettingsStripedRows": "Csíkozott sorok",
    "tabsAll": "Összes",
    "tags": "Címkék",
    "tasks": "Feladatok",
    "taxinvoices": "TA-számlák",
    "team": "Hozzárendelt csapat",
    "threshold": "Küszöbérték",
    "ticket": "Jegy",
    "ticketId": "Kapcsolt jegy",
    "ticketLinked": "Kapcsolt jegy",
    "ticketNumber": "Jegyszám",
    "tickets": "Jegyek",
    "title": "Cím",
    "titleUiPluginParam": "Példa cím",
    "totalArea": "Teljes terület",
    "totalAreaShort": "m²",
    "type": "Típus",
    "typeName": "Típus neve",
    "typeOfUse": "Használat típusa",
    "unit": "Egység",
    "unitName": "Egység neve",
    "uploadedDocument": "Feltöltött dokumentum",
    "uploadFiles": "Fájlok feltöltése",
    "usageType": "Használat típusa",
    "usageTypeAllocationspaceValue": "Kiosztott terület érték",
    "usageTypeMainUsage": "Fő használat",
    "usagetypeName": "Használat típusa név",
    "usageTypeRentalspaceValue": "Bérlemény érték",
    "usageTypeValidFrom": "Érvényes ettől",
    "usageTypeValidTo": "Érvényes eddig",
    "userEmail": "E-mail: {email}",
    "userName": "Felhasználónév: {userName}",
    "users": "Felhasználók",
    "validFrom": "Érvényes ettől",
    "validTo": "Érvényes eddig",
    "vat": "ÁFA",
    "vatRate": "Adókulcs",
    "version": "Verzió",
    "versionAddress": "Cím verzió",
    "versionAddressShort": "VA",
    "versionShort": "V.",
    "view": "Megtekintés",
    "viewlengthLimit": "Bejegyzések maximális száma",
    "widgetIsClassifiedFalse": "feldolgozatlan",
    "widgetIsClassifiedTrue": "feldolgozott",
    "widgetStatusTICKETSTATUS_CLOSED": "feldolgozott",
    "widgetStatusTICKETSTATUS_NEW": "feldolgozatlan",
    "withAttachments": "Mellékletekkel",
    "withoutAttachments": "Mellékletek külön",
    "year": "Év",
    "zip": "Irányítószám"
  },
  "messages": {
    "checklistAllChecked": "Minden pont ki van pipálva",
    "checklistNotAllChecked": "Nem minden pont van kipipálva",
    "contractsPluginReady": "Már van egy szerződés. | {count} szerződés található",
    "documentDetailClassificationAttachment": "Mivel ez a dokumentum melléklet, az értékesítési pont, a dokumentumtípus és a jegy vagy mind szükségesek, vagy egyik sem.",
    "documentDetailClassificationUploadedDocument": "Mivel ez egy feltöltött dokumentum, az értékesítési pont és a dokumentumtípus kötelező. A jegy opcionális.",
    "loadingPDF": "PDF betöltése…",
    "noData": "Nincs adat",
    "noInlinePreview": "Nincs elérhető előnézet",
    "noResults": "Nincs találat",
    "noTableData": "Nincs adat",
    "noTableFilterData": "Nincs találat ezekre a szűrőkre",
    "toggledFullscreenView": "Átváltva egy nézetre",
    "toggledSplitView": "Átváltva osztott nézetre",
    "uiPluginAllChecked": "A feladat teljesítve",
    "uiPluginNotAllChecked": "A feladat még nincs teljesen kész",
    "viewmode": "Nézetmód"
  },
  "months": {
    "1": "Január",
    "2": "Február",
    "3": "Március",
    "4": "Április",
    "5": "Május",
    "6": "Június",
    "7": "Július",
    "8": "Augusztus",
    "9": "Szeptember",
    "10": "Október",
    "11": "November",
    "12": "December"
  },
  "navigation": {
    "access": "Hozzáférés",
    "accountDataRelated": "Számlaadatokhoz kapcsolódó",
    "address": "Cím",
    "administration": "Adminisztráció",
    "areas": "Területek",
    "areaTypes": "Területtípusok",
    "attributeTranslations": "Attribútum-fordítások",
    "authorizations": "Jogosultságok",
    "choices": "Választási lehetőségek",
    "cities": "Városok",
    "claimTypes": "Igénytípusok",
    "classificationOfDocumentEntries": "Beérkezés",
    "companies": "Vállalatok",
    "company": "Seybold belső",
    "companyDatabase": "Ügyfelek",
    "conditionList": "Feltétellista",
    "configInvoiceAndContradictionRelatedData": "Számla- és kifogásadatok konfigurációja",
    "configuration": "Konfiguráció",
    "contactPerson": "Kapcsolattartó",
    "contactsCustomers": "Kapcsolatok",
    "contactsInternal": "Kapcsolatok",
    "contactsPartners": "Kapcsolatok",
    "contractCriteriaTypes": "Szerződés kritériumtípusok",
    "contractDataRelated": "Szerződés adatokhoz kapcsolódó",
    "contracts": "Szerződések",
    "contractsTermsAndConditions": "Szerződések – feltételek",
    "contractTitles": "Szerződés címek",
    "contractTypes": "Szerződéstípusok",
    "contradictionPackages": "Kifogás csomagok",
    "costTypes": "Költségtípusok",
    "countries": "Országok",
    "criteriaAndChoices": "Kritériumok és választások",
    "crud": "CRUD",
    "currencies": "Pénznemek",
    "customergroups": "Csoportok",
    "customers": "Ügyfelek",
    "dashboard": "Vezérlőpult",
    "dashboardOfBoards": "Táblák vezérlőpultja",
    "dashboardTickets": "Jegy vezérlőpult",
    "deadlineList": "Határidő lista",
    "documentContractType": "Dokumentum szerződéstípus",
    "documents": "Dokumentumok",
    "documentTypes": "Dokumentumtípusok",
    "facilityServices": "Létesítménygazdálkodás",
    "favorites": "Kedvencek",
    "functions": "Funkciók",
    "geography": "Helyek",
    "importContract": "Szerződés import",
    "importFunction": "Import funkció",
    "importStandard": "Import szabvány",
    "inbox": "Bejövő",
    "indexClauses": "Indexklauzulák",
    "inspectionResults": "Ellenőrzési eredmények",
    "invoiceAndContradictionData": "Számla- és kifogásadatok",
    "invoiceCriteria": "Számla-kritériumok",
    "invoiceValueTypes": "Számlaérték típusok",
    "kanbanTickets": "Kanban jegyek",
    "kanbanTicketsConfiguration": "Kanban jegyek",
    "languages": "Nyelvek",
    "listOfTicketsAndTasks": "Jegyek és feladatok listája",
    "locations": "Helyszínek",
    "locationTypes": "Helyszín típusok",
    "logout": "Kijelentkezés",
    "main": "Saját Zelos",
    "masterdata": "Törzsadatok",
    "maturityTypes": "Esedékességi típusok",
    "menu": "Menü",
    "miscellaneous": "Egyebek",
    "monthlyindex": "Havi index",
    "myTasksAndTickets": "Saját feladatok és jegyek",
    "myTasksAndTicketsConfiguration": "Saját feladatok és jegyek",
    "newBusiness": "Új üzlet",
    "objectDataRelated": "Objektum adatokhoz kapcsolódó",
    "operations": "Működés",
    "partnerCompanies": "Partner vállalatok",
    "partnercompanyDatabase": "Partnerek",
    "partnergroups": "Csoportok",
    "partners": "Partnerek",
    "partnerTypes": "Partnertípusok",
    "payments": "Kifizetések",
    "pointOfSales": "Értékesítési pontok",
    "pointofsales": "Értékesítési pontok",
    "processes": "Folyamatok",
    "products": "Termékek",
    "rating": "Értékelés",
    "recurringPayment": "Ismétlődő kifizetések",
    "recurringPaymentTypes": "Ismétlődő kifizetés típusok",
    "rentalsAndContracts": "Dokumentumok",
    "resultCategories": "Eredménykategóriák",
    "rights": "Jogok",
    "salutions": "Megszólítás",
    "savingTypes": "Megtakarítás típusok",
    "serviceObjects": "Szolgáltatási objektumok",
    "serviceObjectTypes": "Szolgáltatási objektum típusok",
    "tableGroups": "Táblacsoportok",
    "tables": "Táblák",
    "tags": "Címkék",
    "tapsInvoicePositions": "TAP-ok – számlapozíciók",
    "taxinvoices": "TA – számlák",
    "teams": "Csapatok",
    "textModules": "Szövegmodulok",
    "textTemplates": "Szövegsablonok",
    "textTemplateVariables": "Szöveg sablon változók",
    "ticketListIssue": "Jegylista probléma",
    "ticketPriorities": "Jegy prioritások",
    "tickets": "Jegyek",
    "ticketTypes": "Jegytípusok",
    "trackRecord": "Eredményesség",
    "translations": "Fordítások",
    "units": "Egységek",
    "usageTypes": "Felhasználási típusok",
    "userAdministration": "Felhasználókezelés",
    "userProfile": "Profil",
    "users": "Felhasználók",
    "userTypes": "Felhasználótípusok"
  },
  "pages": {
    "403": {
      "back2Home": "Vissza a kezdőlapra",
      "headline": "Hozzáférés megtagadva",
      "opener": "A kért erőforrás jelenleg nem elérhető az Ön számára",
      "title": "Hozzáférés megtagadva"
    },
    "404": {
      "back2Home": "Vissza a kezdőlapra",
      "headline": "Ez az oldal nem létezik",
      "opener": "Ellenőrizze az elérési utat.",
      "title": "Az oldal nem található"
    },
    "access": {
      "title": "Hozzáférés"
    },
    "address": {
      "title": "Cím"
    },
    "administration": {
      "title": "Adminisztráció"
    },
    "areas": {
      "title": "Területek"
    },
    "areasDetail": {
      "title": "Terület részletei"
    },
    "areasDetailEdit": {
      "title": "Terület szerkesztése"
    },
    "areasNew": {
      "title": "Új terület"
    },
    "areaTypes": {
      "title": "Területtípusok"
    },
    "attributeTranslations": {
      "title": "Attribútum-fordítások"
    },
    "authorizations": {
      "title": "Jogosultságok"
    },
    "choices": {
      "title": "Választási lehetőségek"
    },
    "cities": {
      "title": "Városok"
    },
    "claimTypes": {
      "title": "Igénytípusok"
    },
    "classification": {
      "actions": "Műveletek",
      "attachmentHeadline": "E-mail melléklet",
      "emailHeadline": "E-mail",
      "inbox": "Bejövő",
      "message": "Üzenet",
      "selectMessage": "Válasszon egy elemet a részletek megtekintéséhez.",
      "tabs": {
        "all": "Összes",
        "received": "Beérkezett",
        "received:thisWeek": "Ezen a héten",
        "received:today": "Ma",
        "status": "Állapot",
        "status:closed": "Osztályozott",
        "status:open": "Feldolgozatlan"
      },
      "title": "Beérkezés"
    },
    "classificationOfDocumentEntries": {
      "title": "Dokumentumbejegyzések osztályozása"
    },
    "classificationOfDocumentEntriesV2": {
      "title": "Dokumentumbejegyzések osztályozása V2"
    },
    "companies": {
      "title": "Vállalatok"
    },
    "conditionList": {
      "title": "Feltétellista"
    },
    "configurationKanbanTickets": {
      "title": "Kanban-jegy konfiguráció"
    },
    "contactpersons": {
      "title": "Kapcsolattartók"
    },
    "contactpersonsDetail": {
      "title": "Kapcsolattartó részletei"
    },
    "contactpersonsDetailEdit": {
      "title": "Kapcsolattartó szerkesztése"
    },
    "contactpersonsNew": {
      "title": "Új kapcsolattartó"
    },
    "contractCriteriaTypes": {
      "title": "Szerződés kritériumtípusok"
    },
    "contracts": {
      "extensionValue": "{value} {unit}",
      "tabs": {
        "contractType": "Szerződéstípus",
        "status": "Állapot",
        "status:available": "Állapot: elérhető"
      },
      "title": "Szerződések"
    },
    "contractsDetail": {
      "title": "Szerződés részletei"
    },
    "contractsDetailConditions": {
      "title": "Szerződési feltétel – részletek"
    },
    "contractsDetailConditionsDetailEdit": {
      "title": "Szerződési feltétel szerkesztése"
    },
    "contractsDetailConditionsNew": {
      "title": "Új szerződési feltétel"
    },
    "contractsDetailContractactions": {
      "title": "Szerződés művelet – részletek"
    },
    "contractsDetailContractactionsDetailEdit": {
      "title": "Szerződés művelet szerkesztése"
    },
    "contractsDetailContractactionsNew": {
      "title": "Új szerződés művelet"
    },
    "contractsDetailEdit": {
      "title": "Szerződés szerkesztése"
    },
    "contractsNew": {
      "title": "Új szerződés"
    },
    "contractTitles": {
      "title": "Szerződés címek"
    },
    "contractTypes": {
      "title": "Szerződéstípusok"
    },
    "contradictionPackages": {
      "title": "Kifogás csomagok"
    },
    "costTypes": {
      "title": "Költségtípusok"
    },
    "countries": {
      "title": "Országok"
    },
    "criteriaAndChoices": {
      "title": "Kritériumok és választások"
    },
    "crud": {
      "title": "CRUD"
    },
    "currencies": {
      "title": "Pénznemek"
    },
    "customergroups": {
      "title": "Ügyfélcsoportok"
    },
    "customers": {
      "tabs": {
        "all": "Összes",
        "group": "Csoport",
        "received": "Beérkezett",
        "received:thisWeek": "Ezen a héten",
        "received:today": "Ma",
        "status:closed": "Osztályozott",
        "status:open": "Feldolgozatlan"
      },
      "title": "Ügyfelek"
    },
    "customersDetail": {
      "title": "Ügyfél részletei"
    },
    "customersDetailEdit": {
      "title": "Ügyfél szerkesztése"
    },
    "customersNew": {
      "title": "Új ügyfél"
    },
    "dashboard": {
      "contractactions": "Szerződés műveletek",
      "emailsChart": "E-mailek",
      "emailsUnclassified": "Nem osztályozott e-mailek",
      "latestOpenTickets": "Legújabb nyitott jegyek",
      "openTickets": "Nyitott jegyek",
      "ticketsChart": "Jegyek",
      "title": "Saját Zelos",
      "urgentOpenTickets": "Esedékes jegyek"
    },
    "dashboardBoard": {
      "title": "Vezérlőpult – tábla"
    },
    "dashboardTicket": {
      "title": "Vezérlőpult – jegy"
    },
    "deadlineList": {
      "title": "Határidő lista"
    },
    "documentContractType": {
      "title": "Dokumentum szerződéstípus"
    },
    "documents": {
      "tabs": {
        "all": "Összes",
        "documentType": "Típus",
        "status": "Állapot",
        "status:classified": "Osztályozott",
        "status:unclassified": "Nem osztályozott",
        "type": "Fajta",
        "type:csv": "CSV",
        "type:documents": "Dokumentumok",
        "type:excel": "Excel",
        "type:images": "Képek",
        "type:other": "Egyéb",
        "type:pdf": "PDF",
        "type:word": "Word"
      },
      "title": "Dokumentumok"
    },
    "documentsBatchClassify": {
      "subtitle": "Több dokumentum egyidejű osztályozása",
      "title": "Dokumentumok kötegelt osztályozása"
    },
    "documentsDetail": {
      "batchClassification": "Kötegelt osztályozás",
      "title": "Dokumentum",
      "uploadedHeadline": "Sikeresen feltöltött fájlok",
      "uploadExplanation": "Húzza ide a fájlokat a feltöltéshez",
      "uploadHeadline": "Dokumentumfeltöltés",
      "uploadInProgressMessage": "Feltöltés folyamatban",
      "viewHeadline": "Dokumentum nézet"
    },
    "documentTypes": {
      "title": "Dokumentumtípusok"
    },
    "emails": {
      "headline": "HDL e-mailek",
      "title": "E-mailek"
    },
    "emailsDetail": {
      "headline": "HDL e-mail részletei",
      "title": "E-mail írása"
    },
    "emailsNew": {
      "headline": "HDL új e-mail",
      "title": "Új e-mail"
    },
    "facilityServiceObjects": {
      "title": "Létesítmény-szolgáltatási objektumok"
    },
    "functions": {
      "title": "Funkciók"
    },
    "home": {
      "title": "Kezdőlap"
    },
    "importContract": {
      "title": "Szerződés import"
    },
    "importStandard": {
      "title": "Import szabvány"
    },
    "indexClauses": {
      "title": "Indexklauzulák"
    },
    "inspectionResults": {
      "title": "Ellenőrzési eredmények"
    },
    "invoiceCriteria": {
      "title": "Számla-kritériumok"
    },
    "invoiceValueTypes": {
      "title": "Számlaérték típusok"
    },
    "languages": {
      "title": "Nyelvek"
    },
    "listOfTickets": {
      "title": "Jegyek listája"
    },
    "locations": {
      "title": "Helyszínek"
    },
    "locationTypes": {
      "title": "Helyszíntípusok"
    },
    "login": {
      "logInButton": "Bejelentkezés Entrával",
      "opener": "Nincs bejelentkezve. Jelentkezzen be Entra-fiókkal.",
      "title": "Bejelentkezés"
    },
    "mainKanbanTickets": {
      "title": "Kanban táblák"
    },
    "mainKanbanTicketsKanbanview": {
      "subtitle": "Feladatok a táblán"
    },
    "mainKanbanTicketsView": {
      "subtitle": "Konfiguráció",
      "title": "Kanban tábla"
    },
    "maturityTypes": {
      "title": "Esedékességi típusok"
    },
    "menu": {
      "title": "Menü"
    },
    "monthlyindex": {
      "tabs": {
        "all": "Összes",
        "year": "Év"
      },
      "title": "Havi index"
    },
    "myTasksAndTickets": {
      "title": "Saját feladatok és jegyek"
    },
    "newBusiness": {
      "title": "Új üzlet"
    },
    "partnerCompanies": {
      "title": "Partner vállalatok"
    },
    "partnergroups": {
      "title": "Partnercsoportok"
    },
    "partnergroupsDetail": {
      "title": "Partnercsoport részletei"
    },
    "partnergroupsDetailEdit": {
      "title": "Partnercsoport szerkesztése"
    },
    "partnergroupsNew": {
      "title": "Új partnercsoport"
    },
    "partners": {
      "title": "Partnerek"
    },
    "partnersDetail": {
      "title": "Partner részletei"
    },
    "partnersDetailEdit": {
      "title": "Partner szerkesztése"
    },
    "partnersNew": {
      "title": "Új partner"
    },
    "partnerTypes": {
      "title": "Partnertípusok"
    },
    "payments": {
      "title": "Kifizetések"
    },
    "pointOfSales": {
      "title": "Értékesítési pontok"
    },
    "pointofsales": {
      "title": "Értékesítési pontok"
    },
    "pointofsalesDetail": {
      "title": "Értékesítési pont – részletek"
    },
    "pointofsalesDetailEdit": {
      "title": "Értékesítési pont szerkesztése"
    },
    "pointofsalesNew": {
      "title": "Új értékesítési pont"
    },
    "processes": {
      "endOfProcess": "Folyamat vége",
      "external": "Külső folyamat: {procname}",
      "processAssignedTeam": "Hozzárendelt csapat: {team}",
      "tabs": {
        "isDraft": "Munkaverzió",
        "isDraft:false": "Produktív",
        "isDraft:true": "Vázlat"
      },
      "taskClosed": "Feladat lezárva",
      "title": "Folyamatmodellezés",
      "triggersSectionHeadline": "Aktivált triggerek",
      "uiPluginSectionHeadline": "Akciókomponensek"
    },
    "processesDetail": {
      "title": "Egyedi folyamat"
    },
    "processesEdit": {
      "title": "Folyamat szerkesztése"
    },
    "processesNew": {
      "title": "Új folyamat"
    },
    "products": {
      "title": "Termékek"
    },
    "rating": {
      "title": "Értékelés"
    },
    "recurringPayment": {
      "title": "Ismétlődő kifizetések"
    },
    "recurringPaymentTypes": {
      "title": "Ismétlődő kifizetés típusok"
    },
    "resultCategories": {
      "title": "Eredménykategóriák"
    },
    "salutions": {
      "title": "Megszólítás"
    },
    "savingTypes": {
      "title": "Megtakarítás típusok"
    },
    "serviceObjects": {
      "title": "Szolgáltatási objektumok"
    },
    "serviceObjectTypes": {
      "title": "Szolgáltatási objektum típusok"
    },
    "tableGroups": {
      "title": "Táblacsoportok"
    },
    "tables": {
      "title": "Táblák"
    },
    "tags": {
      "title": "Címkék"
    },
    "tapsInvoicePositions": {
      "title": "TAP számlapozíciók"
    },
    "taxinvoices": {
      "title": "TA számlák"
    },
    "teams": {
      "title": "Csapatok"
    },
    "textModules": {
      "title": "Szövegmodulok"
    },
    "textTemplates": {
      "title": "Szövegsablonok"
    },
    "textTemplateVariables": {
      "title": "Szövegsablon változók"
    },
    "ticketListIssue": {
      "title": "Jegylista – probléma"
    },
    "ticketPriorities": {
      "title": "Jegy prioritások"
    },
    "tickets": {
      "notificationNextStepMaintext": "Következő lépés „{stepName}”",
      "notificationNextStepSubtext": "{stepDescription}",
      "notificationSwitchProcessNextStepMaintext": "Váltás a(z) „{name}” folyamathoz",
      "notificationSwitchProcessNextStepSubtext": "{description}",
      "tabs": {
        "all": "Összes",
        "status": "Állapot",
        "status:inProgress": "Folyamatban",
        "status:openOrNew": "Nyitott",
        "status:overdue": "Esedékes",
        "teams": "Csapat"
      },
      "title": "Jegyek",
      "uiplugin": "Akciókomponens: {name}",
      "uipluginBlockedMain": "Ez a lépés még nincs kész",
      "uipluginBlockedSub": "Fejezze be a nyitott feladatokat",
      "uipluginOpenExternal": "Szerkesztés az oldalon",
      "uipluginOpenInModal": "Megnyitás modalban"
    },
    "ticketsDetail": {
      "headline": "Jegy #{ticketid}",
      "subheadline": "SUB",
      "ticketName": "[{ticketid}] {customerName}{documentType}{entryDate}",
      "title": "Jegy",
      "unnamed": "Feladat"
    },
    "ticketTypes": {
      "title": "Jegytípusok (hamarosan)"
    },
    "trackRecord": {
      "title": "Eredményesség"
    },
    "translations": {
      "title": "Fordítások"
    },
    "undefined": {
      "title": "Ismeretlen oldal"
    },
    "units": {
      "title": "Egységek"
    },
    "unknownPage": {
      "title": "Ismeretlen oldal"
    },
    "usageTypes": {
      "title": "Felhasználási típusok"
    },
    "users": {
      "title": "Felhasználók"
    },
    "userTypes": {
      "title": "Felhasználótípusok"
    }
  },
  "placeholder": {
    "brevoTemplate": "Sablon kiválasztása",
    "columns": "Látható oszlopok",
    "comment": "Új megjegyzés",
    "enterLinkName": "Választás szövege",
    "enterStepname": "Lépés neve",
    "name": "Név",
    "note": "Új jegyzet",
    "noTeamAssigned": "Nincs csapat hozzárendelve",
    "quickfilter": "Gyorsszűrő",
    "selectCustomer": "Ügyfél kiválasztása",
    "selectCustomerGroup": "Ügyfélcsoport kiválasztása",
    "selectExistingAddress": "Válasszon meglévő címet",
    "selectExistingContactPerson": "Válasszon meglévő kapcsolattartót",
    "selectOrCreateStep": "Válasszon lépést vagy hozzon létre újat",
    "selectPointOfSale": "Értékesítési pont kiválasztása",
    "uiPluginParamInputPlaceholder": "Opció szövegének megadása"
  },
  "primevue": {
    "clear": "Törlés",
    "dayNames": [
      "Vasárnap",
      "Hétfő",
      "Kedd",
      "Szerda",
      "Csütörtök",
      "Péntek",
      "Szombat"
    ],
    "dayNamesMin": [
      "V",
      "H",
      "K",
      "Sze",
      "Cs",
      "P",
      "Szo"
    ],
    "dayNamesShort": [
      "V",
      "H",
      "K",
      "Sze",
      "Cs",
      "P",
      "Szo"
    ],
    "firstDayOfWeek": 1,
    "monthNames": [
      "Január",
      "Február",
      "Március",
      "Április",
      "Május",
      "Június",
      "Július",
      "Augusztus",
      "Szeptember",
      "Október",
      "November",
      "December"
    ],
    "monthNamesShort": [
      "Jan",
      "Febr",
      "Márc",
      "Ápr",
      "Máj",
      "Jún",
      "Júl",
      "Aug",
      "Szept",
      "Okt",
      "Nov",
      "Dec"
    ],
    "today": "Ma"
  },
  "text": {
    "attachmentToolbarHeader": "„{attachment}” melléklet az „{email}” e-mailből",
    "contractsFilterActive": "Aktív szűrő: csak ehhez a POS-hoz tartozó szerződések",
    "customerData": "Ügyféladatok",
    "deadlines": "Határidők",
    "detailToolbarHeader": "{name} részletei",
    "detailToolbarHeaderDefault": "Részletes nézet",
    "document": "Dokumentum",
    "documents": "Dokumentumok",
    "emails": "E-mailek",
    "emailToolbarHeader": "„{email}” e-mail, feladó: {name}",
    "masterData": "Törzsadatok",
    "relatedData": "Kapcsolódó adatok",
    "trackRecords": "Változási előzmények",
    "trackRecordsTicket": "Jegyelőzmények"
  },
  "titletags": {
    "addLang": "„{locale}” fordítás hozzáadása",
    "back2list": "Vissza a listához",
    "booleanFalse": "Nem",
    "booleanTrue": "Igen",
    "change": "Módosítás",
    "chooseFiles": "Fájlok kiválasztása",
    "classificationStatusFalse": "Nem osztályozott",
    "classificationStatusTrue": "Osztályozott",
    "collapse": "Szöveg összecsukása",
    "comments": "Egy|{count} megjegyzés|Megjegyzések",
    "expand": "Teljes szöveg megjelenítése",
    "isDraftFalse": "Produktív",
    "isDraftTrue": "Vázlat",
    "notes": "Személyes jegyzet|Jegyzetek (helyben tárolva)",
    "pan": "Húzás mozgatáshoz (Alt vagy jobb egérgomb)",
    "processAssigned": "Hozzárendelt folyamat: „{process}”",
    "processName": "E címke alatt jelenik meg a választás a jegyben",
    "processRemoveOption": "Opció eltávolítása",
    "processRemovePlugin": "Bővítmény eltávolítása",
    "processRemoveTrigger": "Trigger eltávolítása",
    "reorderableRows": "Egyéni sorrend",
    "reorderableRowsEnabled": "Rendezés befejezése",
    "reset": "Visszaállítás",
    "save": "Mentés",
    "showDashboardSettings": "Vezérlőpult beállításai",
    "showPreferenceSettings": "Jegy megjelenítésének beállításai",
    "showTableSettings": "Tábla konfiguráció",
    "stampedFalse": "Nincs bélyeg",
    "stampedTrue": "Bélyegzett",
    "tasks": "Egy feladatot kell megoldani a továbblépéshez.|{count} feladatot kell megoldani a továbblépéshez.",
    "teamAssigned": "Hozzárendelt csapat: „{team}”",
    "ticketEntryDate": "A jegy beérkezésének dátuma",
    "ticketProcessDeadlinedAt": "Cél dátum a jegy lezárásához: {date}",
    "ticketStatus": "Aktuális jegyállapot: „{status}”",
    "ticketStepDeadlinedAt": "Ezt a lépést {date}-ig kell elvégezni",
    "toggleRefresh": "Frissítés",
    "toggleSplitviewOff": "Osztott nézet",
    "toggleSplitviewOn": "Teljes nézet",
    "toggleToEditViewModeOnDblClick": "Dupla kattintással vissza a nézet módhoz",
    "toggleToEditVodeOnDblClick": "Dupla kattintással szerkesztés"
  },
  "toast": {
    "create": {
      "detail": "Bejegyzés létrehozva"
    },
    "default": {
      "detail": "Kérés végrehajtva",
      "summary": "Kész"
    },
    "delete": {
      "detail": "Bejegyzés törölve"
    },
    "error": "Hiba",
    "errors": {
      "brokenJSON": "Hibás JSON-formátum",
      "CANNOT_BE_CREATED": "Elem nem hozható létre",
      "CANNOT_BE_DELETED": "Elem nem törölhető",
      "CANNOT_BE_FOUND": "Elem nem található",
      "CANNOT_BE_UPDATED": "Elem nem frissíthető",
      "Constraint violation exception": "A fájl már létezik",
      "FILE_DOWNLOAD_ERROR": "Hiba a dokumentum letöltésekor.",
      "FILE_NOT_FOUND": "A dokumentum nem található (404).",
      "Internal server error": "Szerveroldali hiba történt"
    },
    "load": {
      "detail": "Adatlista frissítve"
    },
    "position": {
      "detail": "Sorrend globálisan módosítva minden felhasználónál",
      "summary": "Újrendezve"
    },
    "send": {
      "detail": "E-mail elküldve"
    },
    "trigger": {
      "detail": "aktiválva.",
      "summary": "„{id}” trigger"
    },
    "update": {
      "detail": "Bejegyzés frissítve"
    }
  }
}
